import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('cart')) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(items));
  }, [items]);

  // Each cart item: { bike, startTime, endTime, days, totalAmount, promoCode, discountAmount, afterDiscount, gst, finalAmount }
  const addToCart = (item) => {
    setItems(prev => {
      // Replace if same bike already in cart
      const exists = prev.findIndex(i => i.bike._id === item.bike._id);
      if (exists >= 0) {
        const updated = [...prev];
        updated[exists] = item;
        return updated;
      }
      return [...prev, item];
    });
  };

  const removeFromCart = (bikeId) =>
    setItems(prev => prev.filter(i => i.bike._id !== bikeId));

  const clearCart = () => setItems([]);

  const cartTotal = items.reduce((sum, i) => sum + i.finalAmount, 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, clearCart, cartTotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
